import React from 'react';
import { Box } from '@mui/material';
import Header from './components/Header';
import Home from './pages/Home';
import DisclaimerBanner from './components/DisclaimerBanner';
import './App.css';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', py: 3 }}>
        <Home>
          <DisclaimerBanner />
        </Home>
      </Box>
    </Box>
  );
}

export default App; 